<template>
  <div class="input-field">
    <select class="select" v-on:change="updateLanguage()" ref="selector">
      <option v-if="$store.languages.length > 0" value="" disabled selected>Choose a language</option>
      <option v-if="$store.languages.length == 0">No languages were found</option>
      <option v-for="(language,index) in $store.languages" :key="index" v-bind:value="language.id">{{language.name}}</option>
    </select>
    <label>{{label}}</label>
  </div>
</template>
<script>
  export default {
    name: 'LanguagePicker',
    props: {
      label: String,
      selectedLanguage: String

    },
    model: {
      prop: 'selectedLanguage',
      event: 'selectionChanged'
    },
    methods: {
      updateLanguage() {
        if (this.$refs.selector !== undefined) {
          this.$emit('selectionChanged', this.$refs.selector.value)
        }
      }
    },
    mounted() {
      if (this.$el != null) {
        const selector = this.$el.querySelector("select")
        if (selector) {
          M.Select.init(selector, {});
        }
        this.updateLanguage()
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/LanguagePicker.vue